/** admin/games — API. */
import { http } from '../../_shared/http';
import type { GameItem, GamesListResponse, CreateGamePayload, UpdateGamePayload } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapGame = (g: any): GameItem => ({
  id: g.id,
  name: g.name,
  description: g.description,
  isActive: g.isActive,
  worldsCount: g.worldsCount,
  createdAt: g.createdAt,
  updatedAt: g.updatedAt,
});

export const gamesApi = {
  async list(page = 1, limit = 20): Promise<GamesListResponse> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const data = await http.get<{ data?: unknown[]; total?: number; page?: number; limit?: number; totalPages?: number }>(
      `/games/list-all?${params.toString()}`,
    );
    return {
      data: (data.data ?? []).map(mapGame),
      total: data.total ?? 0,
      page: data.page ?? page,
      limit: data.limit ?? limit,
      totalPages: data.totalPages ?? 1,
    };
  },

  async create(payload: CreateGamePayload): Promise<GameItem> {
    return mapGame(await http.post<unknown>('/games/create', payload));
  },

  async update(id: string, payload: UpdateGamePayload): Promise<GameItem> {
    return mapGame(await http.patch<unknown>(`/games/update/${id}`, payload));
  },

  remove: (id: string) => http.del<void>(`/games/delete/${id}`),
};
